/**
 *Retry same API call multiple times as specified
 *@param times, Number, numbers of re-try
 *@param promise, function, a function that returns a promise
 *@return {Promise} if one of retries is successful
 *@return {Error} if none of retries is successful
 *
 */

const retryAPI = (times, promise, ...args) => {
  return promise(...args).catch((e) => {
    if (times > 1) {
      return retryAPI(times - 1, promise, ...args);
    }
    throw new Error(e);
  });
};
export default retryAPI;
